<template>
  <div>
    <!-- {{ orderedSections }} -->
    <div v-if="data">
      <v-card flat>
        <div class="d-flex flex-column">
          <v-card flat>
            <div class="text-h4 py-2 text-center text-sm-start">
              {{ data.name }}
              <div class="caption">
                Ocular Conditions:
                <a
                  :href="'/ocular-conditions/category/' + data.category.slug"
                  >{{ data.category.name }}</a
                >
              </div>
            </div>
          </v-card>
          <!-- {{ data.images }} -->
          <div class="imageRow" v-if="data.images && data.images.length > 0">
            <dialog-lightbox
              :images="data.images"
              :imagePath="imagePath"
              :placeholder="imagePath + 'pathology_placeholder.svg'"
              :iconHeight="180"
              :iconWidth="300"
            ></dialog-lightbox>
          </div>
          <div v-else style="height: 50px"></div>

          <div
            class="d-flex flex-column flex-sm-row sectionDiv"
            :class="$vuetify.breakpoint.smAndUp ? null : 'mb-6'"
            flat
            v-for="(row, i) in contentItems"
            :key="i"
          >
            <div
              class="headerBkg px-2 font-weight-medium d-flex flex-row align-start pa-3"
              :class="headerClass"
            >
              <div>
                <v-icon v-if="row.icon" small class="mr-2"
                  >mdi-{{ row.icon }}</v-icon
                >
              </div>
              <div v-if="row.title">{{ row.title | titleize }}</div>
            </div>
            <div class="py-1 px-3">
              <!-- <div v-for="(cRow, i) in row.value" :key="i" class="py-2 px-2"> -->

              <vue-markdown v-if="row.value">{{
                formatContent(row.value)
              }}</vue-markdown>
              <!-- </div> -->
            </div>
          </div>
          <!-- icd 10 codes -->
          <div class="d-flex flex-column flex-sm-row sectionDiv">
            <div
              class="headerBkg px-2 font-weight-medium d-flex flex-row align-start pa-3"
              :class="headerClass"
              v-if="data.icdNames"
            >
              <v-icon small class="mr-2">mdi-clipboard-text-outline</v-icon>
              <div>Related ICD Codes</div>
            </div>
            <div class="py-1 px-3">
              <div v-for="(name, code) in data.icdNames" :key="code">
                <router-link
                  :to="{ path: `/icd10/${code}` }"
                  class="d-flex flex-row flex-align-start my-1"
                >
                  <div class="font-weight-medium mr-2 codeWidth">
                    {{ code }}
                  </div>
                  <div class="">{{ name | truncate(120) }}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <!-- {{ data.category }} -->
    </div>
    <see-also
      class="pt-6"
      style="max-width: 400px"
      referrer="DZ"
      :identifier="relatedICDCodes"
    ></see-also>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import VueMarkdown from "@adapttive/vue-markdown";
import ConditionsCatsMixin from "@/assets/js/conditions/ConditionsCatsMixin";
import DialogLightbox from "@/components/universalStuff/DialogLightbox";
import LinkToBaseMixin from "@/assets/js/LinkToBaseMixin";
import GetJsonMixin from "@/assets/js/GetJsonMixin";
import SeeAlso from "../universalStuff/SeeAlso.vue";

export default {
  name: "ConditionDetails",
  components: {
    VueMarkdown,
    DialogLightbox,
    SeeAlso,
  },
  mixins: [LinkToBaseMixin, GetJsonMixin, ConditionsCatsMixin],
  props: {
    name: null,
    conditionTypes: null,
    sectionOrder: null,
    sectionObjects: null,
    specialFields: null,
  },
  data: function () {
    return {
      data: null,
      imagePath: "https://eyedock.com/images/ocular_conditions/",
      counter: 0,
      catJson: null,

      // selectedImage: null,
      // imageDialog: false,
    };
  },
  methods: {
    formatContent(text) {
      text = this.prependBaseToMarkdownLinks(text);
      return text;
    },

    callApi() {
      this.data = null;
      this.loading = true;
      if (!this.name) return; // show error?
      ApiServices.conditionDetails(this.name)
        .then((response) => {
          this.data = response.data;
          // this.emitPath();
        })
        .catch((error) => {
          console.log(error);
          this.data = null;
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    classForRow() {
      this.counter++;
      return this.counter % 2 !== 0 ? null : "rowColor";
    },
    // toggleFullscreen(elem) {
    //   this.imageDialog = !this.imageDialog;
    //   this.selectedImage = this.imageDialog ? elem : null;
    // },
  },
  computed: {
    // sections: function () {
    //   return ConditionsCategories.conditionContentSections;
    // },
    headerClass: function () {
      return this.$vuetify.breakpoint.smAndUp ? "bigHead" : "smallHead";
    },

    contentItems: function () {
      if (!this.data || !this.sectionOrder) return [];

      return this.contentSectionsDownloaded(this.data); // from mixin
    },
    relatedICDCodes: function () {
      if (!this.data || !this.data.icd) return null;
      // i want to split and trim this.data.icd
      let codes = this.data.icd.split(",").map((code) => code.trim());
      return codes;
    },
  },
  watch: {
    name(val) {
      if (val) this.callApi();
    },
  },
  mounted() {
    if (this.name) this.callApi();
  },
  metaInfo() {
    return {
      title:
        "EyeDock/Conditions | " + (this.data?.name ? this.data.name : null),
    };
  },
};
</script>

<style scoped>
.bigHead {
  min-width: 170px;
  max-width: 170px;
}
.bigHead {
  width: 100%;
}
.headerBkg {
  background-color: #e0f2ff;
  /* border-bottom: 1px solid #bfd5e5; */
  /* margin-bottom: -1px; */
}
.rowColor {
  background-color: #eaf6ff;
}
.sectionDiv {
  border: 1px solid #bfd5e5;
  margin-bottom: -1px;
}
.imageRow {
  min-height: 200px;
}
</style>
